import { DatePicker, Form, Select } from "antd";
import { useRef, useState } from "react";
import styles from "../styles/page.module.css";
import dayjs from "dayjs";


const StatisticsFilters = ({ id, getSurveyStatistics }) => {
  const [form] = Form.useForm();
  const [type] = useState(undefined);
  const debounceRef = useRef(null);

  const getFormattedData = (fields) => {
    const values = {};
    for (const field of fields) {
      values[field.name] = field.value;
    }
    return values;
  };

  return (
    <Form
      form={form}
      layout="vertical"
      className={styles["statistics-filters"]}
      onFieldsChange={async (fields, allFields) => {
        const typeField = fields.find((field) => field.name.includes("type"));

        const values = getFormattedData(allFields);
        const [start_date = null, end_date = null] = values?.dates ?? [];
        const data = {
          id_survey: Number(id),
          type: values.type,
          start_date: start_date
            ? dayjs(start_date).format("YYYY-MM-DD")
            : null,
          end_date: end_date ? dayjs(end_date).format("YYYY-MM-DD") : null,
          phone: values.phone,
          id_user:
            values.id_user?.length > 0 && !typeField
              ? values.id_user.join(",")
              : null,
          id_zone:
            values.id_zone?.length > 0 && !typeField
              ? values.id_zone.join(",")
              : null,
        };

        if (debounceRef.current) {
          clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
          getSurveyStatistics(data);
        }, 1000);
      }}
    >
      <div className={styles["statistics-filters-item"]}>
        {/* <Form.Item initialValue={1} name={"type"}>
          <Radio.Group
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
            onChange={(e) => {
              form.setFieldsValue({
                id_user: null,
                id_zone: null,
              });
              setType(e.target.value);
            }}
            options={[
              { value: 1, label: "Todos" },
              { value: 2, label: "Ver por ruteros" },
              { value: 3, label: "Ver por oficinas" },
            ]}
          />
        </Form.Item> */}

        <Form.Item
          hidden={type !== 2}
          initialValue={null}
          label="Ruteros"
          name={"id_user"}
        >
          <Select
            style={{ width: 225 }}
            mode="multiple"
            allowClear
            showSearch
            optionFilterProp="label"
            placeholder="Seleccionar ruteros"
            // options={routers?.map((router) => ({
            //   label: router.name,
            //   value: router.id_user,
            // }))}
            maxTagCount={1}
            maxTagTextLength={10}
          />
        </Form.Item>

        <Form.Item
          hidden={type !== 3}
          initialValue={null}
          label="Oficinas"
          name={"id_zone"}
        >
          <Select
            style={{ width: 200 }}
            mode="multiple"
            allowClear
            showSearch
            optionFilterProp="label"
            placeholder="Seleccionar oficina"
            // options={zones?.map((router) => ({
            //   label: router.zone_name,
            //   value: router.id_zone,
            // }))}
            maxTagCount={1}
            maxTagTextLength={10}
          />
        </Form.Item>

        <Form.Item label="Rango de llenado" name={"dates"}>
          <DatePicker.RangePicker format={"DD/MM/YYYY"} />
        </Form.Item>
      </div>

      {/* <Form.Item initialValue={null} name={"phone"}>
        <Input
          style={{ borderRadius: 50, height: 40, width: 286 }}
          placeholder="Número de teléfono"
          suffix={<SearchIcon />}
        />
      </Form.Item> */}
    </Form>
  );
};

export default StatisticsFilters;
